import WarranteeListTableComponent from "./warranteeListTable.container";

export default WarranteeListTableComponent;
